export const parseNewlines = (string: string): string =>
  string.replace(/\\n/g, '\n');
